import { createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "w-40 no-print"
};
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
export default {
  __name: 'LlPagination',
  props: {
    request: Object,
    totalPages: Number,
    total: Number
  },
  emits: ['loadExpenses'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const perPageChanged = newVal => {
      if (!newVal) {
        return;
      }
      props.request.limit = newVal.value;
      emit('loadExpenses');
    };
    const showAll = () => {
      props.request.limit = props.total;
      props.request.currentPage = 1;
      emit('loadExpenses');
    };
    return (_ctx, _cache) => {
      const _component_v_autocomplete = _resolveComponent("v-autocomplete");
      const _component_v_pagination = _resolveComponent("v-pagination");
      return _openBlock(), _createElementBlock(_Fragment, null, [__props.total > 0 ? (_openBlock(), _createBlock(LlSecondaryButton, {
        key: 0,
        size: "small",
        class: "no-print mr-2",
        onClick: showAll
      }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createTextVNode(" Show All ", -1)]))]),
        _: 1
      })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_1, [_createVNode(_component_v_autocomplete, {
        modelValue: __props.request.limit,
        "onUpdate:modelValue": [_cache[0] || (_cache[0] = $event => __props.request.limit = $event), perPageChanged],
        items: [{
          label: 10,
          value: 10
        }, {
          label: 25,
          value: 25
        }, {
          label: 50,
          value: 50
        }, {
          label: 100,
          value: 100
        }],
        density: "compact",
        "item-title": "label",
        "item-value": "value",
        "return-object": "",
        placeholder: "Rows per Page",
        variant: "outlined",
        class: "remove-outline",
        "hide-details": "true"
      }, null, 8, ["modelValue"])]), _createVNode(_component_v_pagination, {
        modelValue: __props.request.currentPage,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => __props.request.currentPage = $event),
        length: __props.totalPages,
        "total-visible": 7,
        density: "compact",
        onClick: _cache[2] || (_cache[2] = $event => _ctx.$emit('loadExpenses')),
        "hide-details": "true"
      }, null, 8, ["modelValue", "length"])], 64);
    };
  }
};